import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/ui-components/button/button.component';
import { CustomLinkDirective } from '@shared/directives/custom-link/custom-link.directive';

@Component({
  selector: 'ac-confirmation-dialog',
  standalone: true,
  imports: [TranslateModule, ButtonComponent, CustomLinkDirective, MatDialogModule],
  template: `
    <p class="title-m c-secondary-dark">{{ data.title | translate }}</p>
    @if (data.message) {
      <p class="paragraph-m c-secondary-medium-dark mt-1 s:mt-2">{{ data.message | translate }}</p>
    }
    <div class="flex flex-col-reverse items-center gap-2 mt-3 s:flex-row s:justify-end s:mt-4">
      <a acSecondaryLink [mat-dialog-close]="false">{{ 'GENERAL.CANCEL' | translate }}</a>
      <button primary-button small class="self-stretch !max-w-none" [mat-dialog-close]="true">
        {{ data.action ?? defaultAction | translate }}
      </button>
    </div>
  `,
  styles: [
    `
      @use '/src/styles/functions';
      @use '/src/styles/mixins/breakpoints';
      :host {
        display: block;
        padding: functions.spacing(2);

        @include breakpoints.mediaBreakpoint('s') {
          padding: functions.spacing(5);
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  protected readonly defaultAction = 'GENERAL.ACCEPT';

  constructor(@Inject(MAT_DIALOG_DATA) readonly data: { title: string; message?: string; action?: string }) {}
}
